import { render, staticRenderFns } from "./EditAttributePool.vue?vue&type=template&id=befa365e&"
import script from "./EditAttributePool.vue?vue&type=script&lang=js&"
export * from "./EditAttributePool.vue?vue&type=script&lang=js&"
import style0 from "./EditAttributePool.vue?vue&type=style&index=0&id=befa365e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports